'use client'

import {useEffect} from 'react'

export default function Home() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.group').forEach(card => {
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        <section
          className="relative overflow-hidden bg-[url(/assets/images/home-banner.webp)] bg-cover bg-center h-[250px] sm:h-[300px] md:h-[338px]">
          <div
            className="absolute bg-[url(/assets/images/home-title.webp)] bg-contain bg-no-repeat bg-center top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-28 md:w-md md:h-32 lg:w-[500px] lg:h-36 xl:w-[616px] xl:h-44"></div>
        </section>

        <section className="relative bg-[#f5f5f5] h-full overflow-hidden">
          <div
            className="hidden md:block absolute right-0 top-0 bg-[url(/assets/images/home-unit-1.webp)] bg-[#F4F4F4] bg-contain bg-no-repeat bg-right w-full h-full opacity-80"></div>
          <div className="relative z-10 px-4 py-8 sm:px-6 lg:px-28 sm:py-16 lg:py-24">
            <div className="w-fit mx-auto">
              <div className="w-full md:w-2/3">
                <div className="bg-[#AA2424] text-white w-fit px-4 py-2.5 sm:px-8 sm:py-6 mb-6 sm:mb-8">
                  <h2 className="text-xl sm:text-2xl font-medium">
                    守护儿童健康，引领用药创新
                  </h2>
                </div>
                <p className="text-base sm:text-lg text-[#323233] leading-relaxed sm:leading-8 tracking-wide">
                  中关村罕萌儿童用药创新研究院便以&ldquo;守护儿童健康，引领用药创新&rdquo;为使命，深耕儿童用药这一细分领域，致力于解决长期以来困扰医疗界的儿童用药难题。其业务范围之广泛，涵盖了从基础学术研究到实际应用推广的全方位链条，为儿童用药领域的发展注入了强劲动力。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 sm:py-16 lg:py-24 bg-white text-[#323233]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 lg:mb-16">
              <h2 className="text-xl sm:text-2xl lg:text-4xl font-medium leading-tight">
                <span className="block mb-2">研究院依托信息化平台和最新AI</span>
                <span className="block">致力于推动儿童用药领域的全面发展</span>
              </h2>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-1.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  儿童用药领域的学术研究
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-2.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  学术交流活动组织与实施
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-3.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  科研成果转化与推广
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-4.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  技术研发与创新
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-5.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  专业技术培训与人才培养
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-6.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  技术咨询服务
                </h4>
              </div>
              <div className="group hover:transform hover:scale-105 transition-all duration-300 text-center">
                <div
                  className={`bg-[url(/assets/images/grid-7.png)] bg-cover bg-no-repeat bg-center shadow-[0px_10px_30px_0px_rgba(94,94,94,0.1)] rounded-full w-24 h-24 lg:w-[121px] lg:h-[121px] mx-auto mb-4 sm:mb-5 group-hover:bg-primary/20 transition-colors`}></div>
                <h4 className="text-base sm:text-lg font-medium text-[#323233] leading-tight px-2">
                  政府委托业务的承接
                </h4>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#f5f5f5] h-full md:h-[383px] overflow-hidden">
          <div className="hidden md:block absolute left-0 w-[610px] h-full">
            <div
              className="bg-[url(/assets/images/home-unit-3.webp)] bg-cover bg-no-repeat bg-left w-[610px] h-full opacity-80"></div>
          </div>

          <div className="hidden md:block absolute right-0 w-[400px] h-full">
            <div
              className="bg-[url(/assets/images/home-unit-2.webp)] bg-cover bg-no-repeat bg-right w-[400px] h-full opacity-80"></div>
          </div>

          <div className="relative z-10 px-4 py-8 sm:px-6 lg:px-40 sm:py-16 lg:py-24">
            <div className="m-fit mx-auto flex justify-end">
              <div className="w-full lg:max-w-[920px] flex flex-col items-end">
                <div
                  className="bg-[#AA2424] text-white w-fit px-4 py-2.5 sm:px-8 sm:py-6 mb-8 text-center lg:w-48 lg:ml-auto">
                  <h2 className="text-xl sm:text-2xl font-medium">
                    我们的优势
                  </h2>
                </div>
                <p
                  className="md:max-w-2/3 text-base sm:text-lg text-[#323233] leading-relaxed sm:leading-8 tracking-wide text-left">
                  我院汇聚了国内外顶尖的儿科专家、药学研究者及跨学科人才，围绕儿童生理特点、疾病谱变化及药物代谢规律等核心问题，开展了一系列深入细致的研究工作，为儿童用药的安全性和有效性提供了坚实的科学依据。
                </p>
              </div>
            </div>
          </div>
        </section>

        <footer className="bg-white py-12 sm:py-16 lg:py-20 text-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-[#969799]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-8">
              <div>
                <h3 className="text-[#323233] mb-3 font-medium">工作时间</h3>
                <p>9:00-18:00（工作日）</p>
              </div>
              <div>
                <h3 className="text-[#323233] mb-3 font-medium">研究院地址</h3>
                <p className="leading-relaxed">
                  北京市朝阳区化工南路9号院1号楼-2至14层101内7层706室
                </p>
              </div>
            </div>

            <div className="mb-8">
              <h4 className="text-[#323233] mb-4 font-medium">友情链接</h4>
              <div
                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 sm:gap-4">
                {[
                  {href: "https://www.nhc.gov.cn/", text: "国家卫生健康委员会"},
                  {href: "https://www.nhsa.gov.cn/", text: "国家医疗保障局"},
                  {href: "https://www.nmpa.gov.cn/", text: "国家药品监督管理局"},
                  {href: "https://wjw.beijing.gov.cn/", text: "北京市卫生健康委员会"},
                  {href: "https://ybj.beijing.gov.cn/", text: "北京市医疗保障局"},
                  {href: "https://yjj.beijing.gov.cn/", text: "北京市药品监督管理局"}
                ].map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block hover:text-[#AA2424] transition-colors duration-200 text-sm leading-relaxed"
                  >
                    {link.text}
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-6">
              <h4 className="text-[#323233] mb-3 font-medium">中关村罕萌儿童用药创新研究院</h4>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#AA2424] transition-colors duration-200"
              >
                京ICP备2025141099号
              </a>
              <a href="javascript:void(0)" className="ml-10">
                互联网药品信息服务资格证书编号：(京)网药械信息备字(2025)第 00365号
              </a>
            </div>
          </div>
        </footer>
      </div>

      <style jsx>{`
          @keyframes fadeIn {
              from {
                  opacity: 0;
                  transform: translateY(20px);
              }
              to {
                  opacity: 1;
                  transform: translateY(0);
              }
          }

          .animate-fade-in {
              animation: fadeIn 0.6s ease-out forwards;
          }
      `}</style>
    </>
  )
}